import {createReducer, on} from '@ngrx/store';
import {DatevWizardLoginActions} from './datev-wizard-login.actions';
import {initialDatevWizardLoginState} from './datev-wizard-login.state.initial';

export const datevWizardLoginReducers = createReducer(
  initialDatevWizardLoginState,

  // OAuth-Callback wird verarbeitet
  on(DatevWizardLoginActions.login, (state) => ({
    ...state,
    processing: true,
    error: undefined
  })),

  // Erfolgreich verarbeitet
  on(DatevWizardLoginActions.loginSuccess, (state) => ({
    ...state,
    processing: false,
    error: undefined
  })),

  // Fehler beim Verarbeiten
  on(DatevWizardLoginActions.loginFailure, (state, {error}) => ({
    ...state,
    processing: false,
    error: error?.message || 'Ein unbekannter Fehler ist aufgetreten'
  })),

  // OAuth-Fehler vom DATEV-Server
  on(DatevWizardLoginActions.oauthError, (state, {errorCode, errorDescription}) => ({
    ...state,
    processing: false,
    error: undefined,
    errorCode,
    errorDescription
  }))
);
